import {createApi} from "api";

export default () => createApi({
  params: {
    version: 2,
  },
});



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/index.js
 **/